<template>
    <div class="bg-white px-5">
        <div class="flex items-center">
            <p
                v-for="(pane, index) in panes"
                :key="index"
                class="px-4 py-2 cursor-pointer font-medium text-lg min-w-150 text-center"
                @click="onClickTab(pane.props.name)"
                :class="tabClasses(pane)"
            >
                {{ $t(pane.props.label) ?? pane.props.name }}
            </p>
        </div>
        <hr style="height: 1px; margin-top: -1px" />
        <div class="py-4">
            <slot :key="currentTab" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, provide, computed, watch } from "vue";
export default defineComponent({
    name: "BTabs",
    props: {
        modelValue: {
            type: String,
            default: "",
        },
    },
    setup(props, { slots, emit }) {
        const currentTab = ref(props.modelValue);
        watch(
            () => props.modelValue,
            (newValue) => {
                currentTab.value = newValue;
            }
        );
        provide(
            "currentTab",
            computed(() => {
                return currentTab.value;
            })
        );
        const panes = slots.default().filter(function (vnode) {
            return vnode.type.name === "BTabPane";
        });
        const tabClasses = (pane) => {
            if (pane.props.warn) {
                return {
                    "text-red-500 border-b border-indigo-800":
                        props.modelValue === pane.props.name,
                };
            } else {
                return {
                    "text-indigo-800 border-b border-indigo-800":
                        props.modelValue === pane.props.name,
                };
            }
        };
        const onClickTab = (name) => {
            emit("update:modelValue", name);
            currentTab.value = name;
        };
        return { panes, onClickTab, tabClasses, currentTab };
    },
});
</script>
